module.exports = __webpack_public_path__ + "img/history_record_1.7f745668.jpg";